import { t } from "@/i18n";
import { useStore } from "vuex";

export function useSaveOrDropModal() {
    const store = useStore();
    return {
        async askToConfirmIfNeeded({
            showModal,
            onConfirmChanges = async () => {},
            onDropChanges = async () => {},
        } = {}) {
            if (showModal) {
                const decision = await store.dispatch("modals/showConfirmModal", {
                    title: t("shared.unsaved_changes.title"),
                    description: t("shared.unsaved_changes.details"),
                    ctaLabel: t("shared.unsaved_changes.action_save"),
                    cancelLabel: t("shared.unsaved_changes.action_drop"),
                    size: "xl",
                    showXButton: false,
                });
                if (decision) {
                    await onConfirmChanges();
                } else {
                    await onDropChanges();
                }
                return decision;
            }
            // return  undefined === No decision (no confirmation needed)
        },
    };
}
